import * as moment from 'moment';
import _upperFirst from 'lodash-es/upperFirst';

import { Injectable } from '@angular/core';
import { FormGroup } from "@angular/forms";

import { IMultiselectOptions } from 'libraries/module/formbuilder/fields/multiselect/multiselect.model';
import { IFieldSpecs, ICheckboxFieldSpecs } from "libraries/module/formbuilder/fields/interfaces/field-specs";
import { IValidator } from "libraries/module/formbuilder/forms/utils/validators/IValidator";
import { IDescriptionLabels } from "libraries/module/formbuilder/fields/form-field/components/field-description/field-description.component";
import { ILabels } from 'libraries/interfaces/ILabels';
import { INumberFieldSpecs } from "libraries/module/formbuilder/fields/number/INumberFieldSpecs";

@Injectable()
export class HelperService {

    /**
     * @method getMultiselectOptions
     * @description : return the accepted data format for multiselect field options === IMultiselectOptions[]
     * @param labels => strings array of the labels can accept enums in certain cases
     * @param values => strings array of the values can accept enums in certain cases
     * @param codes => enums of the code
     */
    public getMultiselectOptions(labels: string[] | any, values: string[] | any, sort: boolean): IMultiselectOptions[] {
        const options = values.map((valueItem: string, i: number) =>
            ({ label: this.getMultiselectOptionLabel(labels, valueItem, i), value: valueItem })
        );

        if (sort) {
            return this.sortOptions(options);
        }

        return options;
    }

    public sortOptions(options: IMultiselectOptions[]): IMultiselectOptions[] {
        const copy = options.slice();

        copy.sort((a: IMultiselectOptions, b: IMultiselectOptions) => (a.label || "").localeCompare(b.label));

        return copy;
    }

    public getMultiselectOptionLabel(labels: string[] | any, value: string, index: number): string {
        const parameter: string | number = Array.isArray(labels) ? index : value;
        return labels[parameter];
    }

    public getSimpleFieldOptions(name: string,
                                 form: FormGroup,
                                 fieldLabels: { [key: string]: string },
                                 fieldDescriptionLabels?: { [key: string]: IDescriptionLabels },
                                 groupName?: string,
                                 validators?: IValidator[]): IFieldSpecs {
        const fieldName: string = groupName ? groupName + _upperFirst(name) : name;
        const formGroup: FormGroup = groupName ? form.get(groupName) as FormGroup : form;

        return {
            formGroup,
            label: fieldLabels[fieldName],
            formControlName: name,
            validators,
            description: fieldDescriptionLabels && fieldDescriptionLabels[fieldName] || null
        };
    }
    public getNumberFieldOptions(name: string,
                                 form: FormGroup,
                                 fieldLabels: { [key: string]: string },
                                 fixed: number,
                                 max?: number,
                                 fieldDescriptionLabels?: { [key: string]: IDescriptionLabels },
                                 groupName?: string,
                                 validators?: IValidator[]): INumberFieldSpecs {
        const fieldName: string = groupName ? groupName + _upperFirst(name) : name;
        const formGroup: FormGroup = groupName ? form.get(groupName) as FormGroup : form;

        return {
            formGroup,
            label: fieldLabels[fieldName],
            className: 'full-field',
            min: 0,
            step: 10,
            fixed,
            max,
            formControlName: name,
            validators,
            description: fieldDescriptionLabels && fieldDescriptionLabels[fieldName] || null
        };
    }

    public getCheckboxFieldOptions(name: string,
                                 form: FormGroup,
                                 fieldLabels: { [key: string]: string },
                                 fieldDescriptionLabels: { [key: string]: IDescriptionLabels },
                                 fieldCheckboxLabels: { [key: string]: string }): ICheckboxFieldSpecs {
        const simpleFieldOptions: IFieldSpecs = this.getSimpleFieldOptions(name, form, fieldLabels, fieldDescriptionLabels);
        return {
            ...simpleFieldOptions,
            checkboxLabel: fieldCheckboxLabels[name],
        };
    }
}
